import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { StepLabel } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RevokeIcon from "@mui/icons-material/Reply";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/AccessTimeFilled";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

const StepLabelField = ({
  step: { action, userName, timeStamp, userRoles },
}) => {
  const getStepAction = (action) => {
    switch (action) {
      case 1:
        return {
          stepLabelProps: {
            StepIconComponent: () => <CheckCircleIcon color="success" />,
          },
          label: "Approved By: ",
        };

      case 2:
        return {
          stepLabelProps: {
            StepIconComponent: () => <CancelIcon color="error" />,
          },
          label: "Rejected By: ",
        };

      case 3:
        return {
          stepLabelProps: {
            StepIconComponent: () => <RevokeIcon color="primary" />,
          },
          label: "Revoked By: ",
        };
      case 4:
        return {
          stepLabelProps: {
            StepIconComponent: () => <PendingIcon color="primary" />,
          },
          label: "",
        };
      default:
        return {};
    }
  };

  const { stepLabelProps, label } = useMemo(
    () => getStepAction(action) ?? {},
    [action]
  );

  return (
    <StepLabel {...stepLabelProps}>
      <div>
        <b>{label}</b>
        {userName}
      </div>
      {userRoles && (
        <div>
          <b>Role(s): </b>
          {userRoles.map(({ name }) => name).join(", ")}
        </div>
      )}
      {timeStamp && (
        <div>
          <b>Date: </b>
          {convertUTCDateToLocalDate(timeStamp).format("DD-MM-YYYY hh:mm:ss A")}
        </div>
      )}
    </StepLabel>
  );
};

StepLabelField.propTypes = {
  step: PropTypes.object,
};

export default StepLabelField;
